import currency from '@/filters/currency'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export const functions = {
    downloadFile: async (src, fileName) => {
        const file = await fetch(src)
        const fileBlob = await file.blob()
        const fileURL = URL.createObjectURL(fileBlob)

        const link = document.createElement('a')
        link.href = fileURL
        link.download = fileName

        document.body.appendChild(link)
        link.click()
        await document.body.removeChild(link)
        return true
    },

    calculateMargin: promotion => {
        const { product, productSet: set, price, wholesaleType } = promotion
        if (
            product.wholesale_price_distribution === null &&
            product.wholesale_price_cash_and_carry === null &&
            product.wholesale_price_external_distribution === null
        ) {
            return 'b/d'
        }
        const wholesalePrices = [
            product.wholesale_price_distribution,
            product.wholesale_price_cash_and_carry,
            product.wholesale_price_external_distribution
        ]
        const wholesalePriceValue = wholesaleType
            ? product[wholesaleType]
            : Math.min(...wholesalePrices.filter(Boolean)) || null
        if (
            !product ||
            wholesalePriceValue === null ||
            wholesalePriceValue === undefined ||
            +price === 0
        ) {
            return 'b/d'
        }

        const buyPriceNet = +wholesalePriceValue
        const vat = (+product.dict_product.vat + 100) / 100

        let cashback, productPrice, sellPriceNet
        if (set) {
            productPrice = +set.price / +set.required_weight
            sellPriceNet = productPrice / vat
            cashback = +product.amount_of_refund
        } else {
            if (price) {
                productPrice = +price
            } else {
                productPrice = +product.maximum_price
            }
            sellPriceNet = productPrice / vat
            cashback = +product.organizer_refund_amount
        }

        const marginValue = sellPriceNet - buyPriceNet
        const marginPercentage = ((marginValue + cashback) / sellPriceNet) * 100

        return isNaN(marginPercentage)
            ? 'b/d'
            : Math.round(marginPercentage * 100) / 100 + '%'
    },
    calculateRefund: promotion => {
        const {
            minimum_amount_of_refund: minRefund = 0,
            maximum_amount_of_refund: maxRefund = 0,
            type: promoType
        } = promotion

        // Convert min and max to numbers
        const min = +minRefund
        let max = +maxRefund

        // Set max to last step prize_amount value for SALES_TARGET promo

        if (promoType === PROMO_TYPES.SALES_TARGET) {
            const lastStep = promotion.salesTargetThresholds?.slice(-1)[0]
            max = +lastStep?.prize_amount || 0
        }

        if (min === 0 || max === 0) {
            // If min or max is 0, return one value
            return currency(min || max, promoType)
        }

        if (min === max) {
            // If min and max are equal, return the value
            return currency(min, promoType)
        }

        // If min and max are different, return the range
        return currency(min, promoType) + ' - ' + currency(max, promoType)
    }
}
